import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';

import { ExerciseModel, WorkoutModel, WorkoutExerciseModel } from '../../../models/models';
import { ConfigurationProvider, ExerciseProvider, WorkoutProvider } from '../../../providers/providers';

@Component({
  selector: 'page-dashboard-workout-set',
  templateUrl: 'dashboard-workout-set.html'
})
export class DashboardWorkoutSetPage {
  exercise: WorkoutExerciseModel = new WorkoutExerciseModel();
  exerciseList: ExerciseModel[] = []
  exercises: ExerciseModel[] = [];
  setsDeleted: number[] = [];
  workout: WorkoutModel;

  constructor(
    private config: ConfigurationProvider,
    private exerciseProvider: ExerciseProvider,
    private params: NavParams,
    private viewCtrl: ViewController,
    private workoutProvider: WorkoutProvider
  ) { }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  dismissView(item = null) {
    this.viewCtrl.dismiss({
      saved: true,
      name: item ? item.FullName : null
    });
  }

  doAdd(set) {
    this.workoutProvider.AddExerciseSet(this.exercise, set.SortOrder + 1);
  }

  doCopy(set) {
    this.workoutProvider.AddExerciseSet(this.exercise, set.SortOrder + 1, Object.assign({}, set));
  }

  doRemove(set) {
    if (set._id) {
      this.setsDeleted.push(set._id);
    }
    this.workoutProvider.RemoveExerciseSet(this.exercise, set);
  }

  doSave() {
    if (this.formIsValid()) {
      this.config.showLoading('Saving...');

      // delete items, if any
      if (this.setsDeleted.length > 0) {
        this.workoutProvider.DeleteExerciseSets(this.setsDeleted);
      }

      // save
      this.workoutProvider.Save(this.workout).then(res => {
        this.config.dismissLoading();
        this.dismissView();
      });
    }
  }

  doSelectExercise(e) {
    this.exercise.ExerciseId = e._id;
    this.exercise.FullName = e.FullName;
    this.exercise.Variation = e.Variation;
    this.exercises = [];
  }

  formIsValid() {
    if (!this.exercise.ExerciseId) {
      this.config.showAlert('Error', 'Must select an exercise.');
      return false;
    }

    return true;
  }

  getItems(ev: any) {
    // Reset items back to all of the items
    this.initializeItems();

    // set val to the value of the searchbar
    const val = ev.target.value;

    // if the value is an empty string don't filter the items
    if (val && val.trim() != '') {
      this.exercises = this.exercises.filter((item) => {
        return (item.FullName.toLowerCase().indexOf(val.toLowerCase()) > -1);
      })
    }
  }

  ionViewWillLoad() {
    this.workout = this.params.get('workout');
    this.exercise = this.params.get('exercise');
    this.exerciseProvider.List().then((lst: ExerciseModel[]) => {
      this.exerciseList = lst;
      this.initializeItems();
      if (this.exercise.FullName) {
        this.exercises = [];
      }
    });
  }

  initializeItems() {
    this.exercises = Object.assign([], this.exerciseList);
  }
}


// WEBPACK FOOTER //
// ./src/pages/dashboard/exercise/dashboard-workout-set.ts